/* @flow */

import { enableInitializing } from 'initializable-reducer';
import type { Action } from '../diplomatico/types';

const initialState = {
  active: false,
  level: {}
};

function courseEditModal(state: Object = initialState, { type, payload }: Action) {
  switch (type) {
    case 'SHOW_COURSE_EDIT_MODAL':
      return {
        active: true,
        ...payload
      };
    case 'HIDE_COURSE_EDIT_MODAL':
      return { ...initialState };
    case 'SET_MODAL_COURSE':
      return {
        ...state,
        ...payload
      };
    default:
      return state;
  }
}

export {
  courseEditModal,
  initialState
};

export default enableInitializing(courseEditModal);
